<template>
  <div class="top-bar-container">
    <div class="top-left-container">
      <div>
        <div class="logo-container">
          <img :src="Logo" alt="ZelfPOS" />
        </div>
        <a id="menu-toggle" class="menu-toggle" @click="debouncedToggleSidebar">
          <span class="menu-toggle-bar menu-toggle-bar--top"></span>
          <span class="menu-toggle-bar menu-toggle-bar--middle"></span>
          <span class="menu-toggle-bar menu-toggle-bar--bottom"></span>
        </a>
      </div>
      <button class="language-btn" @click="openLanguageModal">
        <img
          :src="currentLanguageFlag"
          :alt="t('languageFlag')"
          class="language-flag"
        />
      </button>
    </div>
    <div v-if="foodSearchEnabled" class="top-right-container">
      <div class="search-bar-container">
        <input
          type="text"
          :placeholder="t('searchFoodItem')"
          v-model="searchQuery"
          @input="updateSearch"
        />
        <IconSearch
          :width="18"
          :height="18"
          stroke="#262626"
          stroke-width="2"
        />
      </div>
      <button class="language-btn sm-display-none" @click="openLanguageModal">
        <img
          :src="currentLanguageFlag"
          :alt="t('languageFlag')"
          class="language-flag"
        />
        <!-- <span>{{ currentLanguageLabel }}</span> -->
      </button>
      <button class="btn cart-btn" @click="openCurrentOrderCart">
        <IconCart :width="24" :height="24" fill="currentColor" />
        <div class="cart-bubble">{{ cartCount }}</div>
        <span>{{ t("cart") }}</span>
      </button>
    </div>
  </div>

  <LanguageModal
    :is-open="isLanguageModalOpen"
    @update:isOpen="isLanguageModalOpen = $event"
  />
</template>

<script setup>
import { computed, defineEmits, defineProps, ref } from "vue";
import { useI18n } from "vue-i18n";
import { debounce } from "lodash";
import { useOrderStore } from "@/stores/order";
import { useSystemSettingsStore } from "@/stores/systemSettings";
import { useLanguage } from "@/composables/useLanguage";
import IconSearch from "@/components/icons/iconSearch.vue";
import IconCart from "@/components/icons/iconCart.vue";
import LanguageModal from "@/components/base/modals/languageModal.vue";

const { getLanguage, getLogo } = useSystemSettingsStore();
const { getDefaultLanguage, getFlagUrl } = useLanguage();

const Logo = computed(() => getLogo())

const defaultLanguage = getDefaultLanguage();
const currentLanguage = computed(() => getLanguage() || defaultLanguage);
const currentLanguageFlag = computed(() =>
  getFlagUrl(currentLanguage.value.flag || defaultLanguage.flag)
);
// const currentLanguageLabel = computed(() =>
//   (currentLanguage.value.code || defaultLanguage.code).toUpperCase()
// );

const props = defineProps({
  searchQuery: { type: String, requried: false, default: "" },
  foodSearchEnabled: { type: Boolean, requried: false, default: false },
});

const emit = defineEmits(["update:search", "open-current-order-cart"]);

const { t } = useI18n();

const { getTotalItems } = useOrderStore();
const { toggleSidebar } = useSystemSettingsStore();

const isLanguageModalOpen = ref(false);
const cartCount = computed(() => getTotalItems());
const searchQuery = ref(props.searchQuery);

const debouncedToggleSidebar = debounce(() => {
  toggleSidebar();
}, 300);

const updateSearch = () => {
  emit("update:search", searchQuery.value);
};

const openLanguageModal = () => {
  isLanguageModalOpen.value = true;
};

const openCurrentOrderCart = () => {
  emit("open-current-order-cart");
};
</script>
